import { render, staticRenderFns } from "./MunicipalitiesSelector.vue?vue&type=template&id=904b50f0&scoped=true"
import script from "./MunicipalitiesSelector.vue?vue&type=script&lang=js"
export * from "./MunicipalitiesSelector.vue?vue&type=script&lang=js"
import style0 from "./MunicipalitiesSelector.vue?vue&type=style&index=0&id=904b50f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904b50f0",
  null
  
)

export default component.exports